export enum ClickCtaUxSource {
  BlogStickyCard = 'blog_sticky_card',
  BlogExitIntentModal = 'blog_exit_intent_modal',
  BlogInlineCard = 'blog_inline_card',
  Top = 'top_button',
  TopRightHeader = 'top_right_header_button',
  CreationSelection = 'creation_selection_button',
  Bottom = 'bottom_button',
  TemplateSelection = 'template_selection_button',
  WorkflowBlankCanvasCardButton = 'workflow_blank_canvas_card_button',
  WorkflowBlankCanvasCardText = 'workflow_blank_canvas_card_text',
  WorkflowTemplatesCardButton = 'workflow_templates_card_button',
  WorkflowTemplatesCardText = 'workflow_templates_card_text',
  WorkflowTextToVideoCardButton = 'workflow_text_to_video_card_button',
  WorkflowTextToVideoCardText = 'workflow_text_to_video_card_text',
  WorkflowCard = 'workflow_card',
  FreePlan = 'free_plan_button',
  BusinessPlan = 'business_plan_button',
  UnlimitedPlan = 'unlimited_plan_button',
  FeaturesSelection = 'feature_selection_button',
  LetsConnect = 'lets_connect',
  ClickSupportIcon = 'click_support_icon',
}

export enum ClickCtaType {
  ClickSignup = 'click_signup',
  ClickLogin = 'click_login',
  ClickSupport = 'click_support',
}

export interface BlogSearchProperties {
  search_term: string;
  language: string;
}

export interface ClickCtaEventProperties {
  ux_source: ClickCtaUxSource;
  type: ClickCtaType;
  feature_utm: string;
}

export interface ClickCtaAnalytics {
  event_name: 'click_cta';
  event_properties: ClickCtaEventProperties;
  user_properties?: any;
}

export interface BlogSearchAnalytics {
  event_name: 'search_blog';
  event_properties: BlogSearchProperties;
  user_properties?: any;
}
